import { objectEntries, objectFromEntries } from '~/web-frontend-core/base/lib';
import { AllMobileCategories, ALL_CATEGORY_ID, createAllCategoryState } from '~/web-frontend-core/store/line/outcomes.mobile/additional/categories/All.mobile';
import { COLUMN_WIDTH } from '~/web-frontend-core/api/const/base';
export class AllMultiSelectCategories extends AllMobileCategories {
    constructor(width = COLUMN_WIDTH.MEDIUM, onTablesSelect) {
        super(width, onTablesSelect);
        this.width = width;
        this.select = this.select.bind(this);
    }
    deleteCategories(matchID, categoryIDs) {
        if (categoryIDs.length === 0) {
            return;
        }
        const selectedCategories = this.selectedCategories.get(matchID);
        if (!selectedCategories) {
            return;
        }
        const data = this.getData(matchID);
        if (!data) {
            throw new Error(`No data for ${matchID}`);
        }
        categoryIDs.forEach((categoryID) => {
            selectedCategories.delete(categoryID);
            delete data[categoryID];
        });
        this.select(matchID);
    }
    /**
     * Обновление фильтра таблицы доп.росписи
     * приходит полностью новое состояние, отсутсвующие категории удаляются
     * @example
     * ```
     *    categories.update(matchID, {
     *       [categoryID]: { isSelected: !categoryTab.isSelected }
     *    });
     * ```
     */
    update(matchID, sportID = this.sportID[matchID], config, categoriesLabels, newStates, selected) {
        if (!newStates) {
            return;
        }
        const prevStates = this.getData(matchID);
        if (!prevStates) {
            this.createNewCategories(matchID, sportID, config, newStates, categoriesLabels, selected);
            return;
        }
        // обновляем существующие категории
        objectEntries(newStates).forEach(([categoryID, newState]) => {
            prevStates[categoryID] = Object.assign(prevStates[categoryID] || {}, newState, config);
        });
        prevStates[ALL_CATEGORY_ID] = createAllCategoryState(newStates, prevStates[ALL_CATEGORY_ID] && prevStates[ALL_CATEGORY_ID].isSelected);
        if (categoriesLabels) {
            this.setCategoriesLabels(matchID, categoriesLabels, prevStates);
        }
        const updatedCategories = Object.keys(newStates).concat(ALL_CATEGORY_ID);
        const toDelete = Object.keys(prevStates).filter((categoryID) => updatedCategories.indexOf(categoryID) === -1);
        this.deleteCategories(matchID, toDelete);
    }
    setCategoriesLabels(matchID, categoriesLabels, prevStates) {
        categoriesLabels.forEach(({ id, txt }) => { prevStates[id].label = txt; });
        this.order.set(matchID, [ALL_CATEGORY_ID].concat(categoriesLabels.map(({ id }) => id)));
    }
    /**
     * Выбрать категорию
     * @param matchID
     * @param categoryIDs
     * @param isSelected
     */
    select(matchID, categoryIDs = Array.from(
    // @ts-ignore
    this.selectedCategories.get(matchID) && this.selectedCategories.get(matchID).values() || []), isSelected = true) {
        if (!this.selectedCategories.has(matchID)) {
            return;
        }
        if (categoryIDs.indexOf(ALL_CATEGORY_ID) !== -1) {
            this.unselectCategories(matchID);
            return;
        }
        if (!isSelected) {
            this.unselectCategories(matchID, categoryIDs);
            return;
        }
        this.selectCategories(matchID, categoryIDs);
    }
    selectCategories(matchID, categoryIDs) {
        const selectedCategories = this.selectedCategories.get(matchID);
        if (!selectedCategories) {
            return;
        }
        categoryIDs.forEach((categoryID) => {
            selectedCategories.add(categoryID);
        });
        this.selectTables(matchID);
        const states = objectFromEntries(Array.from(selectedCategories.values() || [])
            .map((categoryID) => [categoryID, { isSelected: true }]));
        const newStates = Object.assign({ [ALL_CATEGORY_ID]: { isSelected: selectedCategories.size === 0 } }, states);
        this.assignStates(matchID, newStates);
    }
    createNewCategories(matchID, sportID, config, newStates, categoriesLabels, selected) {
        const categories = this.createNewCategoriesStates(matchID, sportID, config, newStates, selected);
        if (categoriesLabels) {
            this.setCategoriesLabels(matchID, categoriesLabels, categories);
        }
        this.sportID[matchID] = sportID;
        this.data.set(matchID, categories);
        this.selectedCategories.set(matchID, new Set());
    }
    createNewCategoriesStates(_gameID, _sportID, config, newStates, selected) {
        const categoryAllState = createAllCategoryState(newStates, !selected || selected.length === 0);
        const states = { [ALL_CATEGORY_ID]: categoryAllState };
        for (const categoryID of Object.keys(newStates)) {
            states[categoryID] = Object.assign(Object.assign({}, newStates[categoryID]), config);
        }
        return states;
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/store/line/outcomes/additional/categories/AllMultiSelect.js